import { Actions } from '../../interfaces'
import { VersionYear } from '@/entities/vehicle'

import find from './find'
import fetch from './fetch'
import update from './update'

export const actions: Actions = {
  find,
  fetch,
  update,
}

export default {
  Model: { VersionYear },
  actions: { [VersionYear.name]: actions },
}
